const INITIAL_VALUES = {
  limit: 10,
  offset: 0,
  searchKeyword: '',
  memberId: null,
};
Object.freeze(INITIAL_VALUES);

export default INITIAL_VALUES;
